import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import FalconRoutes from "routes";
import SettingsPanel from "components/settings-panel/SettingsPanel";
import { CloseButton } from "components/common/Toast";

import "react-datepicker/dist/react-datepicker.css";
import "./CustomToastify.css";
import "./App.css";
import "./styles/Style-ar.css";

const App = () => {
	return (
		<Router basename={process.env.PUBLIC_URL}>
			<FalconRoutes />
			<SettingsPanel />
			<ToastContainer closeButton={CloseButton} icon={true} position={toast.POSITION.TOP_RIGHT} autoClose={1000} />
		</Router>
	);
};

export default App;
